import { DragOverlay } from '@dnd-kit/core';
import { PAGE_LAYOUT_LIST_WIDTH } from '@hakimo-ui/hakimo/ui-layout';
import { DragItem } from '../state';
import MultiCamCameraGroupRow from './MultiCamCameraGroupRow';
import MultiCamCameraRow from './MultiCamCameraRow';

interface Props {
  item: DragItem | null;
}

export function MultiCamDragOverlay({ item }: Props) {
  return (
    <DragOverlay>
      {item && (
        <div
          style={{ width: PAGE_LAYOUT_LIST_WIDTH }}
          className="dark:bg-ondark-bg-1 bg-onlight-bg-1 cursor-grabbing rounded-md shadow-lg"
        >
          {item.type === 'camera' ? (
            <MultiCamCameraRow camera={item.camera} checked={item.checked} />
          ) : (
            <MultiCamCameraGroupRow group={item.group} checked={item.checked} />
          )}
        </div>
      )}
    </DragOverlay>
  );
}

export default MultiCamDragOverlay;
